import {FormikErrors} from 'formik';
import {set} from 'lodash-es';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {recommendFieldsType} from '../CreateRecommend/recommendFields';
import {transferSourceType} from './transferFields';
import {newPlanValidator} from '../RecommendsSetUpNew/setUpNewValidator';
import {hasWrapper} from '../CreateRecommend/RecommendSourceDestination/utils';

import {getIsMinor} from '../useSaveRecommendation/helpers';

export const transferValidator = (
  values: recommendFieldsType,
  errors: FormikErrors<recommendFieldsType>
): FormikErrors<recommendFieldsType> => {
  if (!values.goal?.id) {
    if (!values.isSppDa) {
      errors.goal = 'Please select a goal';
    }
  }
  const transferValues = values.transfer;
  if (!transferValues) {
    errors.transfer = 'Please fill in transfer fields';
    return errors;
  }
  // if (!transferValues.reason) {
  //   set(errors, 'transfer.reason', 'Required');
  // }
  if (
    !transferValues.transferSources ||
    Object.values(transferValues.transferSources).length === 0
  ) {
    set(errors, 'transfer.transferSources', 'Please select at least one account');
  } else {
    Object.values(transferValues.transferSources).forEach((source) => {
      if (source.isShellPlan || source.id.includes('shell')) {
        transferShellValidator(source, values.isSppDa, errors);
      }
      if (!values.isLisa) {
        if (values.isSppDa) {
          if (!source.legacyInitialFee?.feeType) {
            set(
              errors,
              `transfer.transferSources.${source.id}.legacyInitialFee.feeType`,
              'Required'
            );
          }
          if (
            source.legacyInitialFee?.feeType === '%' &&
            source.legacyInitialFee.percentageFee === undefined
          ) {
            set(
              errors,
              `transfer.transferSources.${source.id}.legacyInitialFee.percentageFee`,
              'Required'
            );
          }
          if (
            source.legacyInitialFee?.feeType === 'GBP' &&
            source.legacyInitialFee.fixedFee === undefined
          ) {
            set(
              errors,
              `transfer.transferSources.${source.id}.legacyInitialFee.fixedFee`,
              'Required'
            );
          }
        } else if (!source.initialFee) {
          set(errors, `transfer.transferSources.${source.id}.initialFee`, 'Required');
        }
      }
    });
  }
  if (!transferValues.destinationAccount) {
    set(errors, 'transfer.destinationAccount', 'Please select an account');
  }

  if (transferValues.destinationAccount === 'newPlan') {
    const {isMinor} = values;
    newPlanValidator({
      values,
      errors,
      formikKeyPrefix: `transfer.newPlan`,
      context: OVRecommendActionEnum.TRANSFER,
      isLowesPension: values.isLowesPension,
      isTransactBond: values.isTransactBond,
      isMinor,
    });
  } else if (hasWrapper(values.mainPlanType)) {
    const subplansSelected = Object.entries(
      transferValues.destinationValues?.subplans || {}
    ).filter(([id, fields]) => {
      return fields.checked;
    });
    if (
      subplansSelected.length < 1 &&
      transferValues.destinationValues?.isSaltusProvider
    ) {
      set(errors, 'transfer.destinationAccount', 'At least one subplan must be selected');
    }
  }

  return errors;
};

const transferShellValidator = (
  values: transferSourceType,
  isSppDa: boolean,
  errors: FormikErrors<recommendFieldsType>
): FormikErrors<recommendFieldsType> => {
  const key = `transfer.transferSources.${values.id}`;
  if (!values.accountNumber) {
    set(errors, `${key}.accountNumber`, 'Required');
  }
  if (!values.planProvider) {
    set(errors, `${key}.planProvider`, 'Required');
  }
  if (!values.planType) {
    set(errors, `${key}.planType`, 'Required');
  }
  if (!values.planProvider) {
    set(errors, `${key}.planProvider`, 'Required');
  }
  if (!values.planValue) {
    set(errors, `${key}.planValue`, 'Required');
  }
  if (!values.full && !values.singleClientAmount) {
    set(errors, `${key}.singleClientAmount`, 'Required');
  }
  if (!values.contactId) {
    set(errors, `${key}.contactId`, 'Required');
  }
  if (!isSppDa) {
    if (values.isDataGather) {
      if (values.isDataGather === 'yes') {
        if (!values.isAuthorityHeld) {
          set(errors, `${key}.isAuthorityHeld`, 'Required');
        }
      }
    } else {
      set(errors, `${key}.isDataGather`, 'Required');
    }
  }
  return errors;
};
